import { useState } from "react";
import { Button } from "@mui/material";
import { UserX } from "lucide-react";
import { Advisor, AdvisorStatus } from "protogen/common_pb";
import { useAdminDeactivateIdentity } from "../../services/admin";
import FreeIdentityDialog from "./FreeIdentityDialog";

// Frees a deactivated advisor's phone/email/invitee-email for reuse (e.g. so they can sign
// up again as a member). Only enabled once the advisor is deactivated; the backend enforces
// the same rule.
const FreeAdvisorIdentityAction = ({ advisor }: { advisor: Advisor }) => {
  const [open, setOpen] = useState(false);
  const [freed, setFreed] = useState(false);
  const { request, loading } = useAdminDeactivateIdentity(() => {
    setFreed(true);
    setOpen(false);
  });
  const isDeactivated = advisor.status === AdvisorStatus.DEACTIVATED;
  // Freeing prefixes the identity columns with the deactivation tag ("__..."), so an already
  // freed advisor is detectable on load, not just after freeing in this session.
  const alreadyFreed =
    freed ||
    [advisor.username, advisor.personalEmail, advisor.personalPhone].some((v) =>
      v.startsWith("__"),
    );

  return (
    <>
      <Button
        startIcon={<UserX />}
        variant="text"
        sx={{ justifyContent: "start" }}
        disabled={!isDeactivated || alreadyFreed}
        onClick={() => setOpen(true)}
      >
        {alreadyFreed ? "Identity freed" : "Free identity"}
      </Button>
      <FreeIdentityDialog
        open={open}
        name={advisor.displayName}
        loading={loading}
        onClose={() => setOpen(false)}
        onConfirm={() => request({ userRef: advisor.ref })}
      />
    </>
  );
};

export default FreeAdvisorIdentityAction;
